export enum DragTargetState {
  None = 'NONE',
  Valid = 'VALID',
  Invalid = 'INVALID',
  Self = 'SELF',
}
